import tw from 'twin.macro'

const baseStyle = tw`
   relative font-body
`

export default baseStyle
